import axios from 'axios'

const serviceCatalogApi = axios.create({
    baseURL: `${process.env.VUE_APP_SERVICE_CATALOG}`
});

export default serviceCatalogApi